import { render, staticRenderFns } from "./bronzeCrown.vue?vue&type=template&id=90a8ba10"
import script from "./bronzeCrown.vue?vue&type=script&lang=js"
export * from "./bronzeCrown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports